

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();


//replace by chatgpt above

export default {
  async fetch(request, env) {
    const corsHeaders = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS',
      'Access-Control-Allow-Headers': 'Content-Type, Authorization',
    };

    if (request.method === 'OPTIONS') {
      return new Response(null, { headers: corsHeaders });
    }

    if (request.method !== 'POST') {
      return new Response(
        JSON.stringify({
          service: 'Port Safety Scanner API 22',
          version: '1.0',
          status: 'operational',
          endpoints: {
            analyze: {
              method: 'POST',
              path: '/',
              body: {
                image: 'base64 image data',
                industry: 'port|shipping|cargo (optional)',
                sensitivity: 'low|medium|high (optional)',
              },
            },
          },
          timestamp: new Date().toISOString(),
        }),
        {
          headers: {
            ...corsHeaders,
            'Content-Type': 'application/json',
          },
        }
      );
    }

    // ✅ Handle POST requests for analysis
    try {
      const { image, industry = 'port', sensitivity = 'medium' } =
        await request.json();

      if (!image) throw new Error('Missing image data');

      const response = await fetch('https://api.openai.com/v1/chat/completions', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${env.OPENAI_API_KEY}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          model: 'gpt-4o',
          messages: [
            {
              role: 'user',
              content: [
                {
                   type: 'text',
                  text: `Analyze this image for potential safety hazards related to the ${industry} industry with ${sensitivity} sensitivity. Return JSON array only in this format:
[
  {
    "name": "Hazard name",
    "type": "category",
    "severity": "low|medium|high|critical",
    "confidence": 0-1,
    "description": "Brief hazard detail",
    "regulation": "Applicable HSE or IMO/OSHA standard",
    "recommendation": "Recommended safety action"
  }
]`,
                },
                { type: 'image_url', image_url: { url: image } },
              ],
            },
          ],
          max_tokens: 1500,
        }),
      });

      const data = await response.json();
      
      // 🧩 Parse JSON result
      let hazards = [];
   try {
        const content = data.choices?.[0]?.message?.content || '';
        const match = content.match(/\[[\s\S]*\]/);
        hazards = JSON.parse(match ? match[0] : content);
      } catch {
        hazards = [{ name: 'Unknown', severity: 'medium', description: 'Parsing failed' }];
      }

      return new Response(JSON.stringify({ hazards }), {
        headers: { ...corsHeaders, 'Content-Type': 'application/json' },
      });
    } catch (err) {
      return new Response(JSON.stringify({ error: err.message }), {
        status: 500,
        headers: { ...corsHeaders, 'Content-Type': 'application/json' },
      });
    }
  },
};
